// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

//公共样式
import '@static/css/reset.css'

import { Button, Select } from 'element-ui';
Vue.use(Button).use(Select)

router.beforeEach((to, from, next)=>{
  // if (to.meta.title) {
  //   document.title = to.meta.title;
  // }
  next();
})


Vue.config.productionTip = false
Vue.filter('date', (time)=>{
	var d = new Date(Number(time + '000'));
	var m = d.getMonth() + 1 < 10 ? '0'+(d.getMonth() + 1) : d.getMonth() + 1;
	var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
	return d.getFullYear() + '-' + m + '-' + day;
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js